module.exports = __webpack_public_path__ + "img/mt_shop_finger.e0baeef2.png";